import { render, staticRenderFns } from "./registry.vue?vue&type=template&id=cd8f670e"
import script from "./registry.vue?vue&type=script&lang=js"
export * from "./registry.vue?vue&type=script&lang=js"
import style0 from "./registry.vue?vue&type=style&index=0&id=cd8f670e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports